export const columnWidthLocal = 'columnWidth';
